/*
this componet is used by Surface Mount carriers and Wave Solder Pallets
*/

import React, { useState } from 'react';
import _ from 'lodash';
import Cart from 'pu-react/components/ProductCart';

const getRow = (parameters) => {
  if (!parameters) return null;

  const n = _.parseInt(parameters.row_selected);
  return _.isInteger(n) ? n : null;
};

const getColumn = (parameters) => {
  if (!parameters) return null;

  const n = _.parseInt(parameters.column_selected);
  return _.isInteger(n) ? n : null;
};

const computeDiscount = (quantity, unitPrice) => {
  let discount = 0;
  const isFirstOrder = typeof had_previous_order_fixture === 'undefined' ? true : !had_previous_order_fixture;
  if (isFirstOrder && quantity > 0) {
    discount = unitPrice * 0.25;
  }

  if (quantity === 1) return discount;

  let percent = 0;
  if (quantity <= 5) {
    percent = 5
  } else if (quantity <= 10) {
    percent = 7.5
  } else {
    percent = 10;
  }

  discount += (unitPrice * (isFirstOrder ? (quantity - 1) : quantity ) * (percent / 100.00))
  return _.round(discount, 2);
}

export default (props) => {
  const { parameters, quote, onAddToCart } = props;
  const [quantity, setQuantity] = useState(_.get(Spree.initial_cart_data, 'quantity', '1'));
  let unitPrice;
  let totalPrice;
  let discountLabel, discountValue, discountSubtotal = '';
  let leadTime = parameters ? parameters.lead_time : '';
  //
  const row = getRow(parameters);
  const col = getColumn(parameters);
  const pricing = _.get(quote, 'line_items[0].pricing');
  if (pricing && row !== null && col !== null && pricing[row] && pricing[row][col]) {
    unitPrice = parseFloat(pricing[row][col]);
    unitPrice = parseFloat(accounting.toFixed(unitPrice, 2));

    totalPrice = unitPrice * parseFloat(quantity);
    discountLabel = 'Discount'
    let discount = computeDiscount(parseFloat(quantity), unitPrice);

    unitPrice = accounting.formatMoney(unitPrice);
    discountSubtotal = accounting.formatMoney(totalPrice);
    discountValue = accounting.formatMoney(discount);
    totalPrice = accounting.formatMoney((totalPrice - discount));
  }

  const onChangeQuantity = (e) => {
    setQuantity(e.target.value)
    props.onChangeParameter('quantities', [e.target.value]);
  }
  const properties = [
    {
      label: 'Quantity:',
      value: <input type="number"
                    name="quantity"
                    onChange={onChangeQuantity}
                    value={quantity}
                    className="form-control product-qty"
                    min="1" />
    },
    { label: 'Lead Time:', value: leadTime },
  ];

  return (
    <div>
      <Cart
        properties={properties}
        unitPrice={unitPrice}
        totalPrice={totalPrice}
        discountLabel={discountLabel}
        discountValue={discountValue}
        discountSubtotal={discountSubtotal}
        discountAlwaysShow={true}
        onAddToCart={onAddToCart} />
    </div>
  );
};
